import { VariableCategoryDto, VariableCategoriesListDto, VariableNameBatteryDto } from "app/ApiClient";
import { LoadingState } from "types";

export type VariablesState = {
  loading: LoadingState;
  variables: string[];
  variableNameBatteryList: VariableNameBatteryDto[],
  allVariableNameBatteryList: VariableNameBatteryDto[],  
  unfilteredVariableNameBatteryList: VariableNameBatteryDto[],
  numericVariable: string[];
  categories: VariableCategoryDto[];
  categoriesLoading: LoadingState;
  numericVariableLoading: LoadingState;

  variableMetaData: Record<string, VariableCategoryDto[]>,

  bulkCategoriesForVariables: VariableCategoriesListDto[], 
  bulkCategoriesLoading: LoadingState;

  variableCategories : {
    [key: string]:  VariableCategoryDto[];
  }, 
  variableCategoriesLoadingStatus: LoadingState;
};

export const initialVariablesState: VariablesState = {
  loading: LoadingState.idle,
  categories: [],
  variables: [],
  variableNameBatteryList: [],
  allVariableNameBatteryList: [],
  unfilteredVariableNameBatteryList:[],
  numericVariable: [],
  numericVariableLoading: LoadingState.idle,
  categoriesLoading: LoadingState.idle,
  bulkCategoriesForVariables: [], 
  bulkCategoriesLoading: LoadingState.idle, 
  variableMetaData: {},
  variableCategories: {}, 
  variableCategoriesLoadingStatus : LoadingState.idle
};
